import i18n from '@/locales/i18n'

// 表格
const columns = [
    {
        title: null,
        dataIndex: "index",
        width: "60px",
        align: "center",
        scopedSlots: { customRender: 'index' }
    },
    {
        title: i18n.t('businessDispatch.orderStatus'),
        dataIndex: "orderStatus",
        width: "100px",
        align: "center",
        scopedSlots: { customRender: 'orderStatus' }
    },
    {
        title: i18n.t('businessDispatch.transportStatus'),
        dataIndex: "trackStatus",
        width: "120px",
        align: "center",
        scopedSlots: { customRender: 'trackStatus' }
    },
    {
        title: i18n.t('businessDispatch.importExport'),
        dataIndex: "boundType",
        width: "120px",
        align: "center",
        scopedSlots: { customRender: 'boundType' }
    },
   
    {
        title: i18n.t('businessDispatch.billNumber'),
        dataIndex: "blNumber",
        width: "180px",
        align: "center"
    },
    {
        title: i18n.t('businessDispatch.boxRemarks'),
        dataIndex: "remark",
        width: "250px",
        align: "center",
        scopedSlots: { customRender: 'remark' },
        ellipsis: true,
    },
    {
        title: i18n.t('businessDispatch.containerNumber'),
        dataIndex: "containerNumber",
        width: "120px",
        align: "center"
    },
    {
        title: i18n.t('businessDispatch.sealNumber'),
        dataIndex: "containerSeal",
        width: "120px",
        align: "center"
    },
    {
        title: i18n.t('businessDispatch.containerType'),
        dataIndex: "containerSize",
        width: "120px",
        align: "center"
    },
    {
        title: i18n.t('businessDispatch.estimatedCargoWeight'),
        dataIndex: "estimatedWeight",
        width: "120px",
        align: "center",
        scopedSlots: { customRender: 'estimatedWeight' }
    },
    {
        title: i18n.t('businessDispatch.yard'),
        dataIndex: "depot",
        width: "120px",
        align: "center",
        scopedSlots: { customRender: 'popover' },
        ellipsis: true,
    },

    {
        title: i18n.t('businessDispatch.portArea'),
        dataIndex: "portDistrict",
        width: "100px",
        align: "center"
    },
    {
        title: i18n.t('businessDispatch.temporaryStorageYard'),
        dataIndex: "dropDepot",
        width: "100px",
        align: "center"
    },
    {
        title: i18n.t('businessDispatch.boxTime'),
        dataIndex: "planArrivalTime",
        width: "95px",
        align: "center"
    },
    {
        title: i18n.t('businessDispatch.doorpointAddress'),
        dataIndex: "factoryAddress",
        width: "200px",
        align: "center",
        scopedSlots: { customRender: 'factoryAddress' }
    },
    {
        title: i18n.t('businessDispatch.doorpointContact'),
        dataIndex: "factoryContactName",
        width: "100px",
        align: "center",
        scopedSlots: { customRender: 'factoryContactName' }
    },
    {
        title: i18n.t('businessDispatch.contactNumber'),
        dataIndex: "factoryContactPhone",
        width: "105px",
        align: "center",
        scopedSlots: { customRender: 'factoryContactPhone' }
    },
    {
        title: i18n.t('businessDispatch.keyOrderRequirements'),
        dataIndex: "importantContainerReason",
        width: "250px",
        align: "center",
        scopedSlots: { customRender: 'importantContainerReason' },
        ellipsis: true,
    },
    {
        title: i18n.t('businessDispatch.weighingRequirements'),
        dataIndex: "containerWeighingDesc",
        width: "100px",
        align: "center",
        scopedSlots: { customRender: 'containerWeighingDesc'}
    },
    {
        title: i18n.t('businessDispatch.shipName'),
        dataIndex: "vessel",
        width: "150px",
        align: "center"
    },
    {
        title: i18n.t('businessDispatch.voyage'),
        dataIndex: "voyage",
        width: "150px",
        align: "center"
    },
    {
        title: i18n.t('businessDispatch.plateNumber'),
        dataIndex: "truck",
        width: "100px",
        align: "center"
    },
    {
        title: i18n.t('businessDispatch.driver'),
        dataIndex: "driverName",
        width: "80px",
        align: "center"
    },
    {
        title: i18n.t('businessDispatch.phoneNumber'),
        dataIndex: "driverPhone",
        width: "105px",
        align: "center"
    },
    {
        title: i18n.t('businessDispatch.customsClearance'),
        dataIndex: "isDeclaration",
        width: "100px",
        align: "center",
        scopedSlots: { customRender: 'isDeclaration' }
    },
    {
        title: i18n.t('businessDispatch.openingTime'),
        dataIndex: "openingTime",
        width: "95px",
        align: "center"
    },
    {
        title: i18n.t('businessDispatch.closingTime'),
        dataIndex: "closingTime",
        width: "95px",
        align: "center"
    },
    {
        title: i18n.t('businessDispatch.deadlineTime'),
        dataIndex: "documentaryOffTime",
        width: "95px",
        align: "center"
    },
    {
        title: i18n.t('businessDispatch.customer'),
        dataIndex: "customerName",
        width: "250px",
        align: "center"
    },
    {
        title: i18n.t('businessDispatch.businessNumber'),
        dataIndex: "orderNumber",
        width: "150px",
        align: "center"
    },
    {
        title: i18n.t('businessDispatch.listBusinessNo'),
        dataIndex: "businessNo",
        width: "150px",
        align: "center",
    },
    {
        title: i18n.t('businessDispatch.commissionTime'),
        dataIndex: "orderCreateTime",
        width: "120px",
        align: "center"
    }
];

// 订单状态
const orderStatusSelect = [
    { label: i18n.t('all'), value: "" },
    { label: i18n.t('orderReceived'), value: "CONFIRMED" },
    { label: i18n.t('dispatched'), value: "DISPATCHED" },
    // { label: "已完成", value: "FINISHED" },
    // { label: "已退关", value: "TERMINATION" },
    { label: i18n.t('canceled'), value: "CANCELLED" }
]

// 运输状态
const trackStatusSelect = [
    { label: i18n.t('all'), value: "" },
    { label: i18n.t('notPickedUp'), value: "NO_PICKUP" },
    { label: i18n.t('pickedUp'), value: "PICKUP" },
    { label: i18n.t('arrivedAtFactory'), value: "DOOR_ARRIVED" },
    { label: i18n.t('leftFactory'), value: "DOOR_LEFT" },
    { label: i18n.t('returnedContainer'), value: "RETURN_CONTAINER" }
]

// 重点跟单
const importantContainerReasonSelect = [
    { label: i18n.t('all'), value: "" },
    { label: i18n.t('yes'), value: "1" },
    { label: i18n.t('no'), value: "0" },
]


const changeCode = (code, arr) => {
    let value;
    arr.forEach(item => {
        if (item.value === code) {
            value = item.label;
        }
    });
    return value;
}
export {
    columns, changeCode, orderStatusSelect, trackStatusSelect,
    importantContainerReasonSelect,
}